import React, {useEffect, useState} from 'react'
import '@opentok/client'

const fnNoop = () => {
}

const useSession = ({
                  apiKey,
                  sessionId,
                  token,
                  onArchiveStart = fnNoop,
                  onArchiveStopped = fnNoop,
                  onConnectionCreated = fnNoop,
                  onConnectionDestroyed = fnNoop,
                  onMuteForced = fnNoop,
                  onSessionConnected = fnNoop,
                  onSessionDisconnected = fnNoop,
                  onSessionReconnected = fnNoop,
                  onSessionReconnecting = fnNoop,
                  onSignal = fnNoop,
                  onStreamCreated = fnNoop,
                  onStreamDestroyed = fnNoop,
                  onStreamPropertyChanged = fnNoop,
                  onError = (e) => {
                      if(e) {
                          console.error(e)
                      }
                  }
              }) => {
    const [session, setSession] = useState(null)

    useEffect(() => {
        const session = OT.initSession(apiKey, sessionId)
        session.on({
            'archiveStart': onArchiveStart,
            'archiveStopped': onArchiveStopped,
            'connectionCreated': onConnectionCreated,
            'connectionDestroyed': onConnectionDestroyed,
            'muteForced': onMuteForced,
            'sessionConnected': onSessionConnected,
            'sessionDisconnected': onSessionDisconnected,
            'sessionReconnected': onSessionReconnected,
            'sessionReconnecting': onSessionReconnecting,
            'signal': onSignal,
            'streamCreated': onStreamCreated,
            'streamDestroyed': onStreamDestroyed,
            'streamPropertyChanged': onStreamPropertyChanged,
        })
        setSession(session)
    }, [apiKey, sessionId])

    useEffect(() => {
        if (session) {
            session.connect(token, onError)
        }
    }, [token, session])

    useEffect(() => {
        return () => {
            if(session) {
                session.off()
                session.destroy()
            }
        }
    }, []);


    return session
}

export default useSession
